<template>
  <div>
    <vs-row class="module-base-row">
      <vs-col>
        <table class="base-table">
          <thead>
            <tr>
              <th v-for="col in columns" :key="col.key" :class="col.headerClass || null"
                  :style="col.headerStyle || null">
                {{ $t(col.label) | capitalize }}
              </th>
              <th v-if="actions && actions.length" :style="headerActitonStyle">
                {{ $t('actions') | capitalize }}
              </th>
            </tr>
          </thead>

          <tbody> 
            <tr v-for="(row,index) in data" :key="index">
              <td v-for="col in columns" :key="col.key" :class="col.cellClass || null"
                  :style="col.cellStyle || null">
                <slot :name="`col-${col.key}`" :row="row">
                  {{ row[col.key] }}
                </slot>
              </td>
              <td v-if="actions && actions.length" :class="['buttons-row', actionClass || null]"
                  :style="actionStyle || null">
                <div v-for="(action, actionIndex) in actions" :key="'action-' + actionIndex">
                  <base-action-icon
                    v-if="(!action.hideIf || !action.hideIf(row)) && hasPermission(action.permissions)"
                    :tooltip="action.tooltip"
                    :icon="action.icon"
                    :class="action.customClass || null"
                    :style="action.customStyle || null"
                    @click="() => { if (typeof action.onClick === 'function') action.onClick(row) }"
                  />
                </div>
              </td>
            </tr>

            <!-- 🔑 Trigger de infinite scroll -->
            <tr class="base-table-trigger-row">
              <td :colspan="columns.length + (actions && actions.length ? 1 : 0)"
                  class="base-table-trigger-cell">
                <div v-if="data.length" v-observe-visibility="visibilityChanged"></div>
              </td>
            </tr>
          </tbody>
        </table>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import BaseActionIcon from '@/views/app/components/actions/BaseActionIcon.vue';

export default {
  name: 'BaseTable',
  components: { BaseActionIcon },
  props: {
    columns: { type: Array, required: true },
    data: { type: Array, required: true },
    actions: { type: Array },
    actionClass: { type: String, default: null },
    actionStyle: { type: String, default: null },
    headerActitonStyle:{ type:[String, Object, Array], default: () => ({})}
  },
  methods: {
    visibilityChanged(isVisible) {
      if (isVisible) {
        this.$emit('loadMore')
      }
    }
  }

};
</script>

<style scoped>
.module-base-row {
  flex: 1 1 auto;
  min-height: 50px;
}

.base-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 1rem;
  background-color: #fff;
}

.base-table th,
.base-table td {
  padding: 12px 10px;
  word-wrap: break-word;
  font-size: 1rem;
}
.base-table th{
  border-bottom: 1px solid #eee;
}

.base-table thead th {
  position: sticky;
  top: 0;
  background-color: #fff;
  color: #BC1300;
  font-weight: bold;
  font-size: 1.2rem;
  z-index: 10;
  border-bottom: 1px solid #ddd;
}

.base-table tbody tr:hover {
  background-color: #F5F5F5;
  cursor: pointer;
}

.buttons-row {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  min-height: 50px;
  align-items: center;
}

/* 🔑 Trigger aislado: no altera estilos globales */
.base-table-trigger-cell {
  padding: 0;
  border: none;
  background: transparent;
}
</style>